import { useState } from 'react';
export function useRevolvingIndex(maxIndex, startIndex = 0) {
    const [index, setIndex] = useState(startIndex);
    return {
        nextIndex: ()=>index < maxIndex ? setIndex(index + 1) : setIndex(0),
        previousIndex: ()=>index > 0 ? setIndex(index - 1) : setIndex(maxIndex),
        index,
        setIndex
    };
}

//# sourceMappingURL=useRevolvingIndex.js.map